import lodash from 'lodash';

window._ = lodash;

import Axios from 'axios';

window.axios = Axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (!error.response) {
            console.warn('Network error:', error.message);

            return new Promise(() => {});
        }

        if (error.response.status === 401) {
            if (window.location.pathname !== '/login') {
                const target = window.location.pathname + window.location.search;
                window.location.href = '/login?redirect=' + encodeURIComponent(target);
            }

            return new Promise(() => {});
        }

        if (error.response.status === 419) {
            window.location.reload();

            return new Promise(() => {});
        }

        return Promise.reject(error);
    },
);
